/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import UserManagement from "./components/UserManagement/UserManagement"
import BookManagement from "components/BookManagement/BookManagement";
import AddChapter from "components/AddChapter/AddChapter"
import EditChapter from "components/EditChapter/EditChapter";
import PodcastManagement from "components/PodcastManagement/PodcastManagement";
import Addpodcast from "components/AddPodcast/AddPostcast";
import EditPodcast from "components/EditPodcast/EditPodcast";
import ArticleManagement from "components/ArticleManagement/ArticleManagement";
import AddArticle from "components/AddArticle/AddArticle";
import EditArticle from "components/EditArticle/EditArticle";
import TermsAndConditions from "components/TermsAndCondition/Terms&Conditions"
import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicy"
import ContactSupport from 'components/ContactSupport/ContactSupport'
import ReplyContactSupport from "components/ReplyContactSupport/ReplyContactSupport"
import AssociateSRB from "components/AssociatesSRB/AssociatesSRB";
import AddSRB from "components/AddSRB/AddSRB"
import EditSRB from "components/EditSRB/EditSRB";
import AdditionalResources from "components/AdditionalResources/AdditionalResources"
import AddLink from "components/AddLink/AddLink";
import ForgotPassword from "components/ForgotPassword/ForgotPassword";
import ResetPassword from "components/ResetPassword/ResetPassword";
import AddSubChapter from "components/AddSubChapter/AddSubChapter";
import ViewChapter from "components/ViewChapter/ViewChapter";
import ViewSubChapter from "components/ViewSubChapter/ViewSubChapter";
import ChapterDetails from "components/ChapterDetails/ChapterDetails";
import VideoManagement from "components/Video/VideoManagement";
import AddVideo from "components/Video/AddVideo";
import EditVideo from "components/Video/EditVideo";
import AddUser from "components/User/AddUser"
import EditUser from "components/User/EditUser"
import AboutUs from "components/AboutUs/AboutUs";
import StatePage from "components/State-City/StatePage";
import CityPage from "components/State-City/CityPage";

var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
  },

  // User Management - People/Users related
  {
    path: "/user-management",
    name: "User Management",
    icon: "ni ni-circle-08 text-blue",
    component: <UserManagement />,
    layout: "/admin",
  },

  // Book Management - Books/Library related
  {
    path: "/book-management",
    name: "Book Management",
    icon: "ni ni-books text-orange",
    component: <BookManagement />,
    layout: "/admin",
  },

  // Podcast Management - Audio/Media related
  {
    path: "/podcast-management",
    name: "Podcast Management",
    icon: "ni ni-sound-wave text-purple",
    component: <PodcastManagement />,
    layout: "/admin",
  },

  {
    path: "/video-management",
    name: "Video Management",
    icon: "ni ni-tv-2 text-red",
    component: <VideoManagement />,
    layout: "/admin",
  },

  // Article Management - Content/Writing related
  {
    path: "/article-management",
    name: "Article Management",
    icon: "ni ni-paper-diploma text-green",
    component: <ArticleManagement />,
    layout: "/admin",
  },
{
    path: "/state",
    name: "State/City",
    icon: "ni ni-key-25 text-info",
    component: <StatePage />,
    layout: "/admin",
  },

  {
    path: "/city/:id",
    name: "City",
    icon: "ni ni-key-25 text-info",
    component: <CityPage />,
    layout: "/admin",
    sidebar: false,
  },

  // Terms and Conditions - Legal/Document related
  {
    path: "/terms-and-conditions",
    name: "Terms and Conditions",
    icon: "ni ni-single-copy-04 text-yellow",
    component: <TermsAndConditions />,
    layout: "/admin",
  },

  // Privacy Policy - Security/Privacy related
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    icon: "ni ni-lock-circle-open text-red",
    component: <PrivacyPolicy />,
    layout: "/admin",
  },

  // Contact Support - Communication/Help related
  {
    path: "/contact-support",
    name: "Contact Support",
    icon: "ni ni-chat-round text-info",
    component: <ContactSupport />,
    layout: "/admin",
  },

  // Associate SRB - Partnership/Network related
  {
    path: "/associate-srb",
    name: "Associate SRB",
    icon: "ni ni-building text-pink",
    component: <AssociateSRB />,
    layout: "/admin",
  },

  // Additional Resources - Resources/Tools related
  {
    path: "/additional-resources",
    name: "Additional Resources",
    icon: "ni ni-archive-2 text-dark",
    component: <AdditionalResources />,
    layout: "/admin",
  },

  {
    path: "/about-us",
    name: "About Us",
    icon: "ni ni-building text-orange",
    component: <AboutUs />,
    layout: "/admin",
  },

  // Hidden sidebar routes (forms and edit pages)
  {
    path: "/add-chapter",
    name: "Add Chapter",
    icon: "ni ni-fat-add text-success",
    component: <AddChapter />,
    layout: "/admin",
    sidebar: false
  },

  {
    path: "/edit-chapter/:id",
    name: "Edit Chapter",
    icon: "ni ni-ruler-pencil text-warning",
    component: <EditChapter />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/add-podcast",
    name: "Add Podcast",
    icon: "ni ni-fat-add text-success",
    component: <Addpodcast />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/edit-podcast/:id",
    name: "Edit Podcast",
    icon: "ni ni-ruler-pencil text-warning",
    component: <EditPodcast />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/add-article",
    name: "Add Article",
    icon: "ni ni-fat-add text-success",
    component: <AddArticle />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/edit-article/:id",
    name: "Edit Article",
    icon: "ni ni-ruler-pencil text-warning",
    component: <EditArticle />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/reply-contact-support/:id",
    name: "Edit Contact Support",
    icon: "ni ni-ruler-pencil text-warning",
    component: <ReplyContactSupport />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/add-video",
    name: "Add Podcast",
    icon: "ni ni-fat-add text-success",
    component: <AddVideo />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/edit-video/:id",
    name: "Edit Video",
    icon: "ni ni-fat-add text-success",
    component: <EditVideo />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/add-srb",
    name: "Add SRB",
    icon: "ni ni-fat-add text-success",
    component: <AddSRB />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/add-link",
    name: "Add Link",
    icon: "ni ni-fat-add text-success",
    component: <AddLink />,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/add-user",
    name: "Add Link",
    icon: "ni ni-fat-add text-success",
    component: <AddUser />,
    layout: "/admin",
    sidebar: false,
  },
  {
    path: "/edit-user/:id",
    name: "Edit User",
    icon: "ni ni-ruler-pencil text-warning",
    component: <EditUser />,
    layout: "/admin",
    sidebar: false,
  },


  {
    path: "/edit-srb/:id",
    name: "Edit SRB",
    icon: "ni ni-ruler-pencil text-warning",
    component: <EditSRB />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/add-sub-chapter/:id",
    name: "Add Sub Chapter",
    icon: "ni ni-ruler-pencil text-warning",
    component: <AddSubChapter />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/view-chapter/:id",
    name: "View Chapter",
    icon: "ni ni-ruler-pencil text-warning",
    component: <ViewChapter />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/view-sub-chapter/:id",
    name: "View Sub Chapter",
    icon: "ni ni-ruler-pencil text-warning",
    component: <ViewSubChapter />,
    layout: "/admin",
    sidebar: false,
  },

  {
    path: "/chapter-details/:id",
    name: "Chapter Details",
    icon: "ni ni-ruler-pencil text-warning",
    component: <ChapterDetails />,
    layout: "/admin",
    sidebar: false,
  },



  // // Profile and other standard pages
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: <Profile />,
  //   layout: "/admin",
  // },

  // {
  //   path: "/tables",
  //   name: "Tables",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: <Tables />,
  //   layout: "/admin",
  // },

  // Authentication routes
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },

  {
    path: "/forgot-password",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <ForgotPassword />,
    layout: "/auth",
  },
  {
    path: "/reset-password/:token",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <ResetPassword />,
    layout: "/auth",
  },








  // {
  //   path: "/register",
  //   name: "Register",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: <Register />,
  //   layout: "/auth",
  // },
];

export default routes;